function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#415364;}.cls-2{fill:#e65300;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M189.78,81.78H185.9V47.09H173.13V43.64h29.42v3.45H189.78Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M212.13,78.33h20.42v3.45h-24.3V43.64H231.9v3.45H212.13V60.23h18.48v3.4H212.13Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M244,78.33h17.77v3.45H240.14V43.64H244Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M271.48,78.33H291.9v3.45H267.6V43.64h23.65v3.45H271.48V60.23H290v3.4H271.48Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M318.34,75.21h.06l12.77-31.57h5.92V81.78h-3.88V48.65h-.11L319.31,81.78h-2L303.48,48.65h-.11V81.78h-3.88V43.64h5.93Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M351.09,78.33H371.5v3.45H347.21V43.64h23.65v3.45H351.09V60.23h18.48v3.4H351.09Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M379.09,43.64h12.66c9.54,0,20,6.36,20,19.07s-10.5,19.07-20,19.07H379.09ZM383,78.33h7.71c11.47,0,17-7.75,17-15.62s-5.55-15.62-17-15.62H383Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M423.75,81.78h-3.88V43.64h3.88Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M466,75.64c-2.53,3.82-7.44,7.11-14.28,7.11-11.53,0-19.88-8.46-19.88-20s8.52-20,19.88-20c5.6,0,10.94,2.32,13.58,6L462,51.07a12.52,12.52,0,0,0-10.28-5c-9.86,0-15.84,7.76-15.84,16.65s6,16.64,15.84,16.64A13,13,0,0,0,463,73.7Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M476.53,81.78h-3.88V43.64h3.88Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M513.69,76.12h.11V43.64h3.88V81.78h-4.85L490.64,49h-.11V81.78h-3.88V43.64h4.85Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M527.53,81.78h-4.25l16.48-38.14h3.77l16.38,38.14H555.6l-4.2-10H531.68Zm5.61-13.58h16.8L541.54,48Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M185.52,116.14V124h14.76v7.6H185.52v14.81h-9.1V108.27h25.1v7.87Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M209.54,146.41V108.27h9.27v38.14Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M253,146.41l-15.35-24.94h-.16l.21,24.94h-8.94V108.27h10.5l15.3,24.89h.16l-.21-24.89h8.94v38.14Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M292.38,147.43c-11.9,0-20.74-8.18-20.74-20.25,0-12.23,8.84-19.93,20.74-19.93s20.8,7.7,20.8,19.93C313.18,139.25,304.34,147.43,292.38,147.43Zm0-31.88c-6.46,0-10.88,5-10.88,11.63,0,6.9,4.47,11.85,10.88,11.85s10.94-4.95,10.94-11.85C303.32,120.5,298.85,115.55,292.38,115.55Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M340.1,147.43c-11.74,0-20.52-8.18-20.52-20.14,0-12.23,9.05-20,20.68-20,5.34,0,11.1,1.94,14.28,5.6l-6.25,6.25a9.49,9.49,0,0,0-7.7-3.5c-6.41,0-11,5-11,11.69,0,7,4.47,11.69,10.83,11.69a9.74,9.74,0,0,0,8.08-3.88l6.41,6C351.58,145,346.51,147.43,340.1,147.43Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M385,146.41V130.47H370.15v15.94h-9.21V108.27h9.21v14.44H385V108.27h9.21v38.14Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M404.19,146.41V108.27h9.27v38.14Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M423.42,146.41V108.27h25.64v7.81H432.31v7.17h15.84v7.38H432.31v7.92H450v7.86Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M474.54,116.14v30.27h-9.21V116.14H454.55v-7.87h30.76v7.87Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M507.93,116.14v30.27h-9.21V116.14H487.94v-7.87H518.7v7.87Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M542.35,147.43c-11.91,0-20.74-8.18-20.74-20.25,0-12.23,8.83-19.93,20.74-19.93s20.79,7.7,20.79,19.93C563.14,139.25,554.31,147.43,542.35,147.43Zm0-31.88c-6.47,0-10.88,5-10.88,11.63,0,6.9,4.47,11.85,10.88,11.85s10.93-4.95,10.93-11.85C553.28,120.5,548.81,115.55,542.35,115.55Z"
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "71.74 89.77 87.16 89.77 87.16 74.34 96.84 74.34 96.84 89.77 112.27 89.77 112.27 99.44 96.84 99.44 96.84 114.87 87.16 114.87 87.16 99.44 71.74 99.44 71.74 89.77"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 102.55,
  y: 74.34,
  width: 9.72,
  height: 9.95
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M127.08,135.87H56.93a2.06,2.06,0,0,0-2.06,2.06v9.77a8.82,8.82,0,0,0,8.8,8.81h56.67a8.81,8.81,0,0,0,8.8-8.81v-9.77A2.06,2.06,0,0,0,127.08,135.87ZM125,147.7a4.68,4.68,0,0,1-4.67,4.68H63.67A4.69,4.69,0,0,1,59,147.7V140h66Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M98.2,144.12H85.82a2.07,2.07,0,1,0,0,4.13H98.2a2.07,2.07,0,0,0,0-4.13Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M120.35,32.71H63.67a8.81,8.81,0,0,0-8.8,8.8v9.77a2.06,2.06,0,0,0,2.06,2.06h70.15a2.06,2.06,0,0,0,2.06-2.06V41.51A8.8,8.8,0,0,0,120.35,32.71ZM125,49.21H59v-7.7a4.69,4.69,0,0,1,4.68-4.68h56.67A4.69,4.69,0,0,1,125,41.51v7.7Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M102.32,41H81.69a2.07,2.07,0,0,0,0,4.13h20.63a2.07,2.07,0,1,0,0-4.13Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M127.08,49.21H56.93a2.06,2.06,0,0,0-2.06,2.07v86.65A2.06,2.06,0,0,0,56.93,140h70.15a2.06,2.06,0,0,0,2.06-2.07V51.28A2.06,2.06,0,0,0,127.08,49.21ZM125,135.87H59V53.34h66v82.53Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M139.38,79.59a2.06,2.06,0,1,0-4,1.15,50,50,0,0,1,0,27.78,2.07,2.07,0,0,0,1.41,2.56,2.25,2.25,0,0,0,.58.08,2.08,2.08,0,0,0,2-1.49,54,54,0,0,0,0-30.08Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.61,108.52a49.83,49.83,0,0,1,0-27.78,2.07,2.07,0,0,0-4-1.16,54,54,0,0,0,0,30.09,2.06,2.06,0,0,0,2,1.49,2.24,2.24,0,0,0,.57-.08A2.07,2.07,0,0,0,48.61,108.52Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.23,94.61c0-8.4,1.4-16.17,4-21.86a2.06,2.06,0,0,0-3.77-1.68c-2.77,6.21-4.3,14.57-4.3,23.54s1.53,17.32,4.3,23.53a2.08,2.08,0,0,0,1.89,1.23,2.12,2.12,0,0,0,.84-.18,2.07,2.07,0,0,0,1-2.73C35.63,110.77,34.23,103,34.23,94.61Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M149.6,71.07a2.06,2.06,0,0,0-3.77,1.68c2.55,5.7,3.95,13.46,3.95,21.86s-1.4,16.16-3.95,21.85a2.06,2.06,0,1,0,3.77,1.68c2.78-6.21,4.31-14.57,4.31-23.53S152.38,77.28,149.6,71.07Z"
});

function SvgLogoTmFinochiettoG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 589.94 183.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTmFinochiettoG);
export default __webpack_public_path__ + "static/media/logo_tm_finochietto_g.5ea58a60.svg";
export { ForwardRef as ReactComponent };